import EnbSyncLoader from './EnbSyncLoader'
import { 
  VueSpinner,
  VueSpinnerAudio,
  VueSpinnerBall,
  VueSpinnerBars,
  VueSpinnerBox,
  VueSpinnerClock,
  VueSpinnerComment,
  VueSpinnerDots,
  VueSpinnerFacebook,
  VueSpinnerGears,
  VueSpinnerGrid,
  VueSpinnerHourglass,
  VueSpinnerInfinity,
  VueSpinnerOrbit,
  VueSpinnerOval,
  VueSpinnerPie,
  VueSpinnerPuff,
  VueSpinnerRadio,
  VueSpinnerRing,
  VueSpinnerTail
} from 'vue3-spinners'

export const loaders = {
  EnbSyncLoader,
  VueSpinner,
  VueSpinnerAudio,
  VueSpinnerBall,
  VueSpinnerBars,
  VueSpinnerBox,
  VueSpinnerClock,
  VueSpinnerComment,
  VueSpinnerDots,
  VueSpinnerFacebook,
  VueSpinnerGears,
  VueSpinnerGrid,
  VueSpinnerHourglass,
  VueSpinnerInfinity,
  VueSpinnerOrbit,
  VueSpinnerOval,
  VueSpinnerPie,
  VueSpinnerPuff,
  VueSpinnerRadio,
  VueSpinnerRing,
  VueSpinnerTail
}

export const alias = [
  'EnbSyncLoader',
  'VueSpinner',
  'VueSpinnerAudio',
  'VueSpinnerBall',
  'VueSpinnerBars',
  'VueSpinnerBox',
  'VueSpinnerClock',
  'VueSpinnerComment',
  'VueSpinnerCube',
  'VueSpinnerDots',
  'VueSpinnerFacebook',
  'VueSpinnerGears',
  'VueSpinnerGrid',
  'VueSpinnerHourglass',
  'VueSpinnerInfinity',
  'VueSpinnerlos',
  'VueSpinnerOrbit',
  'VueSpinnerOval',
  'VueSpinnerPie',
  'VueSpinnerPuff',
  'VueSpinnerRadio',
  'VueSpinnerRing',
  'VueSpinnerTail'
]
